import { render, staticRenderFns } from "./goods-detail-drawer.vue?vue&type=template&id=1d602f1a&scoped=true&"
import script from "./goods-detail-drawer.vue?vue&type=script&lang=js&"
export * from "./goods-detail-drawer.vue?vue&type=script&lang=js&"
import style0 from "./goods-detail-drawer.vue?vue&type=style&index=0&id=1d602f1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d602f1a",
  null
  
)

export default component.exports